// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  position: relative;
}

body {
  height: 100vh;
  font-family: "Inter", sans-serif !important;
  -webkit-user-select: unset;
          user-select: unset;
}
body a {
  text-decoration: none;
}

.ant-upload-drag {
  background: transparent !important;
}

.extras-color-badge .ant-badge-status-dot {
  width: 24px;
  height: 24px;
}

.card-view.ant-card-hoverable:hover {
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
}
.card-view .ant-card-body {
  padding: 0;
}
.card-view .ant-card-body a {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  color: var(--dark);
}
.card-view .ant-card-body a .text {
  margin: 0 10px;
  font-weight: 500;
}
.card-view .ant-card-body a svg {
  font-size: 22px;
}

img,
svg {
  vertical-align: baseline !important;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 2;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.ck .ck-content {
  height: 400px !important;
  max-height: 400px !important;
  border: 1px solid var(--input-border) !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}
.ck .ck-content:hover {
  border: 1px solid var(--box-shadow);
}

.ck .ck-toolbar {
  border: 1px solid var(--input-border) !important;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}
.ck .ck-toolbar:hover {
  border: 1px solid var(--box-shadow);
}

.ant-modal.large-modal {
  width: 800px !important;
}

.label-hidden label {
  visibility: hidden;
}

.ant-descriptions:not(.ant-descriptions-bordered) .ant-descriptions-item-label {
  font-weight: bold;
}

.ant-card.h-100 .ant-card-body {
  height: 100%;
}

.global-settings .ant-card.h-100 {
  background: rgba(255, 255, 255, 0.28);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(15px);
  border: none;
}
.global-settings .ant-card.h-100 .ant-result-icon .anticon svg {
  fill: rgb(35, 163, 0);
}
.global-settings .ant-card.h-100 .ant-result-title {
  color: var(--bg-color);
  font-size: 28px;
}
.global-settings .ant-card.h-100 .ant-result-subtitle {
  color: var(--bg-color);
}
.global-settings .ant-card.h-100 .ant-card-body {
  height: auto;
}

.story_img .ant-upload-list-item-actions {
  display: block;
}
.story_img .ant-upload-list-item-actions .anticon-eye svg {
  font-size: 16px;
}

.ant-upload-list-item-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-upload-list-item-actions .anticon-eye svg {
  font-size: 20px;
}

.extra-color-wrapper-contain {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.extra-img-wrapper-contain {
  width: auto;
  max-height: 25px;
  margin-top: 7px;
  border-radius: 8px;
}

.page-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #fafafb;
}

[data-theme=dark] .loader {
  background-color: rgba(27, 37, 49, 0.5);
}
[data-theme=dark] .page-loading {
  background-color: var(--dark-blue);
}
[data-theme=dark] .ant-menu-inline {
  border-right: none;
}
[data-theme=dark] .card-view .ant-card-body a {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast .Toastify__toast-theme--light {
  color: var(--light-text);
  background: var(--dark-blue);
}
[data-theme=dark] .antd-toast .Toastify__close-button--light {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast .Toastify__toast-body {
  height: 60px !important;
  color: var(--light-text);
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 500;
}
[data-theme=dark] .ck.ck-editor__main > .ck-editor__editable {
  background: var(--dark-background);
}
[data-theme=dark] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar {
  background: var(--dark-background);
  border-color: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar * {
  color: var(--light-text) !important;
}
[data-theme=dark] .ck.ck-button:not(.ck-disabled):hover,
[data-theme=dark] a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar .ck.ck-toolbar__separator {
  background: var(--dark-grey);
}

.cs-avatar {
  overflow: hidden !important;
}
.cs-avatar img {
  width: 40px;
  height: 40px;
  overflow: hidden !important;
}

.antdImgUpload .anticon-delete {
  display: none !important;
}

.antdImgUpload .anticon-eye {
  margin-left: 35px !important;
}

.map-button {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  right: 10px;
  bottom: 190px;
  border: none;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
}

.google-map-button {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  right: 10px;
  bottom: 120px;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  font-size: 20px;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
}

.map-container {
  position: relative;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin: 10px 0 !important;
}

.alert {
  padding: 15px 16px;
  background: #cfe2ff;
  margin-bottom: 20px;
  border-radius: 8px;
  color: #000000;
}

.alert-header {
  display: flex;
  align-items: center;
}
.alert-header p {
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  padding: 0;
  margin: 0;
}

.alert-icon {
  font-size: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.ant-form-item-control-input-content .ant-input-suffix .anticon-eye-invisible svg {
  fill: var(--bg-color);
}
.ant-form-item-control-input-content .ant-input-suffix .anticon-eye svg {
  fill: var(--bg-color);
}
.ant-form-item-control-input-content .ant-input-suffix .ant-form-item-feedback-icon {
  margin-left: 10px;
}

[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .anticon-eye-invisible svg {
  fill: #b4bed2;
}
[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .anticon-eye svg {
  fill: #b4bed2;
}
[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .ant-form-item-feedback-icon {
  margin-left: 10px;
}

.order {
  position: relative;
}
.order .ant-image-mask {
  border-radius: 8px;
}
.order .ant-image-mask:hover {
  border-radius: 8px;
}
.order .show-bonus {
  position: absolute;
  right: 12px;
  top: 0px;
  background: #283142;
  color: white;
  border-radius: 8px;
  padding: 3px 12px;
}

.report-products .ant-card-body {
  border: 1px solid transparent;
  transition: all ease-in-out 300ms;
  border-radius: 10px;
  cursor: pointer;
}
.report-products .ant-card-body:hover {
  border: 1px solid #3e79f7;
}
.report-products .active .ant-card-body {
  border: 1px solid rgba(62, 121, 247, 0.6);
  background: rgba(62, 121, 247, 0.1);
}

.borderRadius {
  border-radius: 8px;
}

.extras .ant-image-mask {
  border-radius: 8px;
}

.settings-button .icon {
  font-size: 18px;
  animation: animate 5s ease-in-out infinite;
  justify-content: space-between;
}

.text-hover {
  transition: all 0.3s ease-in-out;
}
.text-hover:hover {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  color: #3e79f7;
}

.textEditor .ck .ck-content {
  min-height: 300px !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

.textEditor .ck .ck-toolbar {
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: #dedede !important;
}

[data-theme=dark] .ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: rgba(92, 92, 92, 0.9) !important;
}

.allDeleteButton {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px !important;
}

.ant-upload .ant-upload {
  padding: 2px;
}
.ant-upload .ant-upload img {
  overflow: hidden;
  border-radius: 8px !important;
}

.address {
  border: 1px solid #4d5b75;
  border-radius: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 11px;
  cursor: pointer;
  overflow: hidden;
  overflow: hidden;
  white-space: nowrap;
}

.ant-form-item-control-input-content .rmdp-container {
  width: 100% !important;
}

.order-details {
  background: white !important;
}

[data-theme=dark] .order-details {
  background: #455560 !important;
}

.order_detail .map_show {
  border-color: #3093fa !important;
  padding: 5px 12px;
  color: #3093fa !important;
  font-size: 14px;
  cursor: pointer;
}

.order-card-title {
  font-size: 16px;
  color: #1a3353;
}

[data-theme=dark] .order-card-title {
  font-size: 16px;
  color: #d6d7dc;
}

.datepicker {
  background: transparent;
  width: 100%;
}

.datepicker .rdp-caption_label {
  font-size: 24px;
  line-height: 33px;
  font-weight: 500;
  text-transform: capitalize;
}

.datepicker .rdp-head_cell {
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  text-transform: none;
}

.datepicker .rdp-table {
  border-collapse: separate;
  border-spacing: 10px;
}

.datepicker .rdp-tbody {
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
}

.datepicker .rdp-cell {
  width: 45px;
  height: 45px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

[data-theme=dark] .datepicker .rdp-cell {
  width: 45px;
  height: 45px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

.datepicker .rdp-day {
  width: 45px;
  max-width: 45px;
  height: 45px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
}

.datepicker .rdp-day_selected:focus:not([aria-disabled=true]) {
  border: 1px solid #000;
}

.datepicker .rdp-button:focus,
.rdp-button:active {
  border: 1px solid transparent;
}

.rdp-months .rdp-table .rdp-cell .rdp-day_selected {
  color: white !important;
  background: #3e79f7 !important;
}

.rdp-months .rdp-table .rdp-cell .rdp-button_reset:hover {
  color: white !important;
  background: #3e79f7 !important;
}

.rdp-months .rdp-table .rdp-cell .rdp-day_today {
  color: rgb(0, 0, 0) !important;
}

[data-theme=dark] .rdp-months .rdp-table .rdp-cell .rdp-day_today {
  color: rgb(255, 255, 255) !important;
}

@media (max-width: 576px) {
  .datepicker .rdp-caption_label {
    font-size: 22px;
    line-height: 26px;
  }
  .datepicker .rdp-nav {
    width: 30%;
  }
  .datepicker .rdp-head_cell {
    font-size: 14px;
    line-height: 19px;
  }
  .datepicker .rdp-table {
    border-spacing: 6px;
  }
  .datepicker .rdp-tbody {
    border-radius: 8px;
  }
  .datepicker .rdp-cell {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
  .datepicker .rdp-day {
    width: 28px;
    max-width: 28px;
    font-size: 14px;
    height: 30px;
    border-radius: 8px;
  }
}
.statistic-card {
  border: 1px solid #e6ebf1;
  font-size: 23px !important;
}
.statistic-card .statistic-box {
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

[data-theme=dark] .statistic-card {
  border: 1px solid #4d5b75;
}

.modal_collapse {
  background: transparent !important;
}
.modal_collapse .order_card {
  border: 1px solid #e6ebf1;
}

[data-theme=dark] .modal_collapse .order_card {
  border: 1px solid #4d5b75;
}

.addon-menu .ant-card {
  border: 1px solid var(--border-color);
}

[data-theme=dark] .addon-menu .ant-card {
  border: 1px solid var(--border-color-bg-dark) !important;
}

.pac-container {
  display: none;
}

.minus-button,
.plus-button {
  background: none !important;
  border: none !important;
  color: #1a3353 !important;
}
.minus-button:hover,
.plus-button:hover {
  background: none !important;
  border: none !important;
}

[data-theme=dark] .minus-button,
[data-theme=dark] .plus-button {
  background: none !important;
  border: none !important;
  color: #b4bed2 !important;
}
[data-theme=dark] .minus-button:hover,
[data-theme=dark] .plus-button:hover {
  background: none !important;
  border: none !important;
}

.order-card {
  transition: all ease 300ms;
}
.order-card:hover .ant-card-actions {
  display: block;
}
.order-card:hover {
  opacity: 0.8;
}
.order-card .ant-card-actions {
  display: none;
}
.order-card .ant-card-meta-title {
  margin-bottom: 0 !important;
}
.order-card .ant-list-items .ant-list-item {
  padding: 4px 0 !important;
  border-bottom: none;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:first-child {
  font-size: 16px;
  font-weight: 600;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 170px;
  white-space: nowrap;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:last-child {
  font-size: 13px;
  font-weight: 500;
}
.order-card .ant-list {
  margin-top: 16px;
}

.ant-alert.new {
  border-top: 2px solid #16a4d8 !important;
}
.ant-alert.accepted {
  border-top: 2px solid #9b5fe0 !important;
}
.ant-alert.cooking {
  border-top: 2px solid #e05f5f !important;
}
.ant-alert.delivered {
  border-top: 2px solid #8bd346 !important;
}
.ant-alert.ready {
  border-top: 2px solid #efdf48 !important;
}
.ant-alert.canceled {
  border-top: 2px solid #d64e12 !important;
}
.ant-alert.on_a_way {
  border-top: 2px solid #f9a52c !important;
}
.ant-alert.pause {
  border-top: 2px solid #552cf9 !important;
}

.order-board {
  max-width: auto;
  overflow-x: scroll;
  display: flex;
  gap: 24px;
}

.dnd-column {
  min-width: 250px;
}
.dnd-column .h-screen {
  padding: 0 8px;
  padding-top: 8px;
  background: var(--global-bg);
  border-radius: 8px;
}
.dnd-column .ant-alert {
  background: var(--global-bg);
  border-radius: 8px !important;
  border: 0.5px solid var(--border-color);
}

[data-theme=dark] .h-screen {
  background: var(--bg-color);
}
[data-theme=dark] .ant-alert {
  background: var(--bg-color);
  border: 0.5px solid var(--ingrediend-border);
}

.order-filter {
  width: 100%;
}
.order-filter .ant-space-item {
  width: calc((100% - 48px) / 6);
}

.hiddin-input {
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(20px) !important;
}

.search-outlined .ant-input-suffix {
  opacity: 0;
}
.search-outlined:hover .ant-input-suffix {
  opacity: 0.5;
  cursor: pointer;
}

.search-outlined-none .ant-input-suffix {
  opacity: 0;
}

.video-upload .ant-upload {
  display: block;
  height: 108px !important;
}
.video-upload .ant-upload.ant-upload-select-picture-card {
  margin: 0 !important;
  padding: 0 !important;
}

.uploaded-file {
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 8px;
  border-radius: 8px;
  padding: 4px 8px;
}
.uploaded-file .media-item {
  cursor: pointer;
  transition: all ease 200ms;
}
.uploaded-file .media-item:hover {
  color: #fff;
}
.uploaded-file .delete-media-item {
  cursor: pointer;
  transition: all ease 200ms;
}
.uploaded-file .delete-media-item:hover {
  color: red;
}

.media-container {
  width: 100%;
  height: auto;
  padding: 4px 16px;
  font-size: 16px;
}
.media-container .item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 4px 16px;
  margin-bottom: 8px;
}
.media-container .item .delete-button {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all ease 200ms;
}
.media-container .item .delete-button:hover {
  color: red;
}

@media print {
  .invoice-print-container {
    padding: 20px 15px !important;
  }
}
.pos-system-product-card-title {
  height: 42px;
  font-size: 14px !important;
  font-weight: 500 !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,2CAAA;EACA,0BAAA;UAAA,kBAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;;AAIA;EACE,kCAAA;AADF;;AAKE;EACE,WAAA;EACA,YAAA;AAFJ;;AAOE;EACE,4CAAA;AAJJ;AAOE;EACE,UAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AALN;AAOM;EACE,cAAA;EACA,gBAAA;AALR;AAQM;EACE,eAAA;AANR;;AAYA;;EAEE,mCAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AATF;;AAYA;EACE,wBAAA;EACA,4BAAA;EACA,gDAAA;EACA,0CAAA;EACA,2CAAA;AATF;AAWE;EACE,mCAAA;AATJ;;AAaA;EACE,gDAAA;EACA,uCAAA;EACA,wCAAA;AAVF;AAYE;EACE,mCAAA;AAVJ;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAeE;EACE,iBAAA;AAZJ;;AAiBE;EACE,YAAA;AAdJ;;AAmBE;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,2BAAA;EACA,YAAA;AAhBJ;AAoBQ;EACE,qBAAA;AAlBV;AAuBI;EACE,sBAAA;EACA,eAAA;AArBN;AAwBI;EACE,sBAAA;AAtBN;AAyBI;EACE,YAAA;AAvBN;;AA6BE;EACE,cAAA;AA1BJ;AA6BM;EACE,eAAA;AA3BR;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA9BF;AAiCI;EACE,eAAA;AA/BN;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAjCF;;AAqCE;EACE,uCAAA;AAlCJ;AAqCE;EACE,kCAAA;AAnCJ;AAsCE;EACE,kBAAA;AApCJ;AAyCM;EACE,wBAAA;AAvCR;AA4CE;EACE,wBAAA;AA1CJ;AA4CI;EACE,wBAAA;EACA,4BAAA;AA1CN;AA6CI;EACE,wBAAA;AA3CN;AA8CI;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA5CN;AAgDE;EACE,kCAAA;AA9CJ;AAiDE;EACE,8BAAA;AA/CJ;AAkDE;EACE,kCAAA;EACA,8BAAA;AAhDJ;AAkDI;EACE,mCAAA;AAhDN;AAoDE;;EAEE,4BAAA;AAlDJ;AAqDE;EACE,4BAAA;AAnDJ;;AAuDA;EACE,2BAAA;AApDF;AAsDE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AApDJ;;AAwDA;EACE,wBAAA;AArDF;;AAwDA;EACE,4BAAA;AArDF;;AAwDA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AArDF;;AAwDA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AArDF;;AAwDA;EACE,kBAAA;AArDF;;AAwDA;;;;EAIE,yBAAA;AArDF;;AAwDA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AArDF;;AAwDA;EACE,aAAA;EACA,mBAAA;AArDF;AAuDE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AArDJ;;AAyDA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAtDF;;AA4DM;EACE,qBAAA;AAzDR;AA8DM;EACE,qBAAA;AA5DR;AAgEI;EACE,iBAAA;AA9DN;;AAsEM;EACE,aAAA;AAnER;AAwEM;EACE,aAAA;AAtER;AA0EI;EACE,iBAAA;AAxEN;;AA6EA;EACE,kBAAA;AA1EF;AA4EE;EACE,kBAAA;AA1EJ;AA4EI;EACE,kBAAA;AA1EN;AA8EE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA5EJ;;AAiFE;EACE,6BAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AA9EJ;AAgFI;EACE,yBAAA;AA9EN;AAmFI;EACE,yCAAA;EACA,mCAAA;AAjFN;;AAsFA;EACE,kBAAA;AAnFF;;AAsFA;EACE,kBAAA;AAnFF;;AAuFE;EACE,eAAA;EACA,0CAAA;EACA,8BAAA;AApFJ;;AAwFA;EACE,gCAAA;AArFF;AAuFE;EACE,gCAAA;EACA,eAAA;EACA,cAAA;AArFJ;;AAyFA;EACE,4BAAA;EACA,0CAAA;EACA,2CAAA;AAtFF;;AAyFA;EACE,uCAAA;EACA,wCAAA;AAtFF;;AAyFA;;EAEE,8BAAA;AAtFF;;AAyFA;;EAEE,4CAAA;AAtFF;;AAyFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAtFF;;AA0FE;EACE,YAAA;AAvFJ;AAyFI;EACE,gBAAA;EACA,6BAAA;AAvFN;;AA4FA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAzFF;;AA4FA;EACE,sBAAA;AAzFF;;AA4FA;EACE,4BAAA;AAzFF;;AA4FA;EACE,8BAAA;AAzFF;;AA4FA;EACE,gCAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,cAAA;AAzFF;;AA4FA;EACE,uBAAA;EACA,WAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAzFF;;AA4FA;EACE,yBAAA;EACA,oBAAA;AAzFF;;AA4FA;EACE,4CAAA;EACA,mBAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,sCAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,sCAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AAzFF;;AA4FA;EACE,sBAAA;AAzFF;;AA4FA;;EAEE,6BAAA;AAzFF;;AA4FA;EACE,uBAAA;EACA,8BAAA;AAzFF;;AA4FA;EACE,uBAAA;EACA,8BAAA;AAzFF;;AA4FA;EACE,8BAAA;AAzFF;;AA4FA;EACE,oCAAA;AAzFF;;AA4FA;EACE;IACE,eAAA;IACA,iBAAA;EAzFF;EA4FA;IACE,UAAA;EA1FF;EA6FA;IACE,eAAA;IACA,iBAAA;EA3FF;EA8FA;IACE,mBAAA;EA5FF;EA+FA;IACE,kBAAA;EA7FF;EAgGA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EA9FF;EAiGA;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EA/FF;AACF;AAkGA;EACE,yBAAA;EACA,0BAAA;AAhGF;AAkGE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAhGJ;;AAoGA;EACE,yBAAA;AAjGF;;AAoGA;EACE,kCAAA;AAjGF;AAmGE;EACE,yBAAA;AAjGJ;;AAsGE;EACE,yBAAA;AAnGJ;;AAwGE;EACE,qCAAA;AArGJ;;AA0GE;EACE,wDAAA;AAvGJ;;AA2GA;EACE,aAAA;AAxGF;;AA2GA;;EAEE,2BAAA;EACA,uBAAA;EACA,yBAAA;AAxGF;AA0GE;;EACE,2BAAA;EACA,uBAAA;AAvGJ;;AA2GA;;EAEE,2BAAA;EACA,uBAAA;EACA,yBAAA;AAxGF;AA0GE;;EACE,2BAAA;EACA,uBAAA;AAvGJ;;AA2GA;EACE,0BAAA;AAxGF;AA2GI;EACE,cAAA;AAzGN;AAuGE;EAKE,YAAA;AAzGJ;AA4GE;EACE,aAAA;AA1GJ;AA6GE;EACE,2BAAA;AA3GJ;AA+GI;EACE,yBAAA;EACA,mBAAA;AA7GN;AAgHQ;EACE,eAAA;EACA,gBAAA;AA9GV;AAiHQ;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA/GV;AAkHQ;EACE,eAAA;EACA,gBAAA;AAhHV;AAsHE;EACE,gBAAA;AApHJ;;AAyHE;EACE,wCAAA;AAtHJ;AAyHE;EACE,wCAAA;AAvHJ;AA0HE;EACE,wCAAA;AAxHJ;AA2HE;EACE,wCAAA;AAzHJ;AA4HE;EACE,wCAAA;AA1HJ;AA6HE;EACE,wCAAA;AA3HJ;AA8HE;EACE,wCAAA;AA5HJ;AA+HE;EACE,wCAAA;AA7HJ;;AAiIA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA9HF;;AAiIA;EACE,gBAAA;AA9HF;AAgIE;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AA9HJ;AAiIE;EACE,4BAAA;EACA,6BAAA;EACA,uCAAA;AA/HJ;;AAoIE;EACE,2BAAA;AAjIJ;AAoIE;EACE,2BAAA;EACA,4CAAA;AAlIJ;;AAsIA;EACE,WAAA;AAnIF;AAqIE;EACE,8BAAA;AAnIJ;;AAuIA;EACE,yCAAA;EACA,sCAAA;AApIF;;AAwIE;EACE,UAAA;AArIJ;AAyII;EACE,YAAA;EACA,eAAA;AAvIN;;AA6IE;EACE,UAAA;AA1IJ;;AA+IE;EACE,cAAA;EACA,wBAAA;AA5IJ;AA8II;EACE,oBAAA;EACA,qBAAA;AA5IN;;AAiJA;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA9IF;AAgJE;EACE,eAAA;EACA,0BAAA;AA9IJ;AAgJI;EACE,WAAA;AA9IN;AAkJE;EACE,eAAA;EACA,0BAAA;AAhJJ;AAkJI;EACE,UAAA;AAhJN;;AAqJA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAlJF;AAoJE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAlJJ;AAmJI;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAjJN;AAmJM;EACE,UAAA;AAjJR;;AAuJA;EACE;IACE,6BAAA;EApJF;AACF;AAuJA;EACE,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AArJF;;AAwJA;EACE,wBAAA;AArJF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  position: relative;\n}\n\nbody {\n  height: 100vh;\n  font-family: 'Inter', sans-serif !important;\n  user-select: unset;\n\n  a {\n    text-decoration: none;\n  }\n}\n\n.ant-upload-drag {\n  background: transparent !important;\n}\n\n.extras-color-badge {\n  .ant-badge-status-dot {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.card-view {\n  &.ant-card-hoverable:hover {\n    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);\n  }\n\n  .ant-card-body {\n    padding: 0;\n\n    a {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      height: 100%;\n      padding: 24px;\n      color: var(--dark);\n\n      .text {\n        margin: 0 10px;\n        font-weight: 500;\n      }\n\n      svg {\n        font-size: 22px;\n      }\n    }\n  }\n}\n\nimg,\nsvg {\n  vertical-align: baseline !important;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba($color: #fff, $alpha: 0.5);\n  z-index: 2;\n  user-select: none;\n  pointer-events: none;\n}\n\n.ck .ck-content {\n  height: 400px !important;\n  max-height: 400px !important;\n  border: 1px solid var(--input-border) !important;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n\n  &:hover {\n    border: 1px solid var(--box-shadow);\n  }\n}\n\n.ck .ck-toolbar {\n  border: 1px solid var(--input-border) !important;\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n\n  &:hover {\n    border: 1px solid var(--box-shadow);\n  }\n}\n\n.ant-modal.large-modal {\n  width: 800px !important;\n}\n\n.label-hidden label {\n  visibility: hidden;\n}\n\n.ant-descriptions:not(.ant-descriptions-bordered) {\n  .ant-descriptions-item-label {\n    font-weight: bold;\n  }\n}\n\n.ant-card.h-100 {\n  .ant-card-body {\n    height: 100%;\n  }\n}\n\n.global-settings {\n  .ant-card.h-100 {\n    background: rgba(255, 255, 255, 0.28);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(15px);\n    border: none;\n\n    .ant-result-icon {\n      .anticon {\n        svg {\n          fill: rgb(35, 163, 0);\n        }\n      }\n    }\n\n    .ant-result-title {\n      color: var(--bg-color);\n      font-size: 28px;\n    }\n\n    .ant-result-subtitle {\n      color: var(--bg-color);\n    }\n\n    .ant-card-body {\n      height: auto;\n    }\n  }\n}\n\n.story_img {\n  .ant-upload-list-item-actions {\n    display: block;\n\n    .anticon-eye {\n      svg {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.ant-upload-list-item-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .anticon-eye {\n    svg {\n      font-size: 20px;\n    }\n  }\n}\n\n.extra-color-wrapper-contain {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.extra-img-wrapper-contain {\n  width: auto;\n  max-height: 25px;\n  margin-top: 7px;\n  border-radius: 8px;\n}\n\n.page-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  background-color: #fafafb;\n}\n\n[data-theme='dark'] {\n  .loader {\n    background-color: rgba($color: #1b2531, $alpha: 0.5);\n  }\n\n  .page-loading {\n    background-color: var(--dark-blue);\n  }\n\n  .ant-menu-inline {\n    border-right: none;\n  }\n\n  .card-view {\n    .ant-card-body {\n      a {\n        color: var(--light-text);\n      }\n    }\n  }\n\n  .antd-toast {\n    color: var(--light-text);\n\n    .Toastify__toast-theme--light {\n      color: var(--light-text);\n      background: var(--dark-blue);\n    }\n\n    .Toastify__close-button--light {\n      color: var(--light-text);\n    }\n\n    .Toastify__toast-body {\n      height: 60px !important;\n      color: var(--light-text);\n      font-size: 14px;\n      letter-spacing: 1px;\n      font-weight: 500;\n    }\n  }\n\n  .ck.ck-editor__main > .ck-editor__editable {\n    background: var(--dark-background);\n  }\n\n  .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n    border-color: var(--dark-grey);\n  }\n\n  .ck.ck-toolbar {\n    background: var(--dark-background);\n    border-color: var(--dark-grey);\n\n    * {\n      color: var(--light-text) !important;\n    }\n  }\n\n  .ck.ck-button:not(.ck-disabled):hover,\n  a.ck.ck-button:not(.ck-disabled):hover {\n    background: var(--dark-grey);\n  }\n\n  .ck.ck-toolbar .ck.ck-toolbar__separator {\n    background: var(--dark-grey);\n  }\n}\n\n.cs-avatar {\n  overflow: hidden !important;\n\n  img {\n    width: 40px;\n    height: 40px;\n    overflow: hidden !important;\n  }\n}\n\n.antdImgUpload .anticon-delete {\n  display: none !important;\n}\n\n.antdImgUpload .anticon-eye {\n  margin-left: 35px !important;\n}\n\n.map-button {\n  cursor: pointer;\n  position: absolute;\n  z-index: 99;\n  right: 10px;\n  bottom: 190px;\n  border: none;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  color: #000000;\n}\n\n.google-map-button {\n  cursor: pointer;\n  position: absolute;\n  z-index: 99;\n  right: 10px;\n  bottom: 120px;\n  border: none;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  font-size: 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  color: #000000;\n}\n\n.map-container {\n  position: relative;\n}\n\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin: 10px 0 !important;\n}\n\n.alert {\n  padding: 15px 16px;\n  background: #cfe2ff;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  color: #000000;\n}\n\n.alert-header {\n  display: flex;\n  align-items: center;\n\n  p {\n    color: #000000;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n.alert-icon {\n  font-size: 30px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.ant-form-item-control-input-content {\n  .ant-input-suffix {\n    .anticon-eye-invisible {\n      svg {\n        fill: var(--bg-color);\n      }\n    }\n\n    .anticon-eye {\n      svg {\n        fill: var(--bg-color);\n      }\n    }\n\n    .ant-form-item-feedback-icon {\n      margin-left: 10px;\n    }\n  }\n}\n\n[data-theme='dark'] .ant-form-item-control-input-content {\n  .ant-input-suffix {\n    .anticon-eye-invisible {\n      svg {\n        fill: #b4bed2;\n      }\n    }\n\n    .anticon-eye {\n      svg {\n        fill: #b4bed2;\n      }\n    }\n\n    .ant-form-item-feedback-icon {\n      margin-left: 10px;\n    }\n  }\n}\n\n.order {\n  position: relative;\n\n  .ant-image-mask {\n    border-radius: 8px;\n\n    &:hover {\n      border-radius: 8px;\n    }\n  }\n\n  .show-bonus {\n    position: absolute;\n    right: 12px;\n    top: 0px;\n    background: #283142;\n    color: white;\n    border-radius: 8px;\n    padding: 3px 12px;\n  }\n}\n\n.report-products {\n  .ant-card-body {\n    border: 1px solid transparent;\n    transition: all ease-in-out 300ms;\n    border-radius: 10px;\n    cursor: pointer;\n\n    &:hover {\n      border: 1px solid #3e79f7;\n    }\n  }\n\n  .active {\n    .ant-card-body {\n      border: 1px solid rgba($color: #3e79f7, $alpha: 0.6);\n      background: rgba(62, 121, 247, 0.1);\n    }\n  }\n}\n\n.borderRadius {\n  border-radius: 8px;\n}\n\n.extras .ant-image-mask {\n  border-radius: 8px;\n}\n\n.settings-button {\n  .icon {\n    font-size: 18px;\n    animation: animate 5s ease-in-out infinite;\n    justify-content: space-between;\n  }\n}\n\n.text-hover {\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    color: #3e79f7;\n  }\n}\n\n.textEditor .ck .ck-content {\n  min-height: 300px !important;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n}\n\n.textEditor .ck .ck-toolbar {\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n}\n\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background: #dedede !important;\n}\n\n[data-theme='dark'] .ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background: rgba(92, 92, 92, 0.9) !important;\n}\n\n.allDeleteButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 36px !important;\n}\n\n.ant-upload {\n  .ant-upload {\n    padding: 2px;\n\n    img {\n      overflow: hidden;\n      border-radius: 8px !important;\n    }\n  }\n}\n\n.address {\n  border: 1px solid #4d5b75;\n  border-radius: 12px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 11px;\n  cursor: pointer;\n  overflow: hidden;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.ant-form-item-control-input-content .rmdp-container {\n  width: 100% !important;\n}\n\n.order-details {\n  background: white !important;\n}\n\n[data-theme='dark'] .order-details {\n  background: #455560 !important;\n}\n\n.order_detail .map_show {\n  border-color: #3093fa !important;\n  padding: 5px 12px;\n  color: #3093fa !important;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.order-card-title {\n  font-size: 16px;\n  color: #1a3353;\n}\n\n[data-theme='dark'] .order-card-title {\n  font-size: 16px;\n  color: #d6d7dc;\n}\n\n.datepicker {\n  background: transparent;\n  width: 100%;\n}\n\n.datepicker .rdp-caption_label {\n  font-size: 24px;\n  line-height: 33px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.datepicker .rdp-head_cell {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.datepicker .rdp-table {\n  border-collapse: separate;\n  border-spacing: 10px;\n}\n\n.datepicker .rdp-tbody {\n  border: 1px solid #00000010;\n  border-radius: 12px;\n}\n\n.datepicker .rdp-cell {\n  width: 45px;\n  height: 45px;\n  border: 1px solid #00000010;\n  border-radius: 12px;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme='dark'] .datepicker .rdp-cell {\n  width: 45px;\n  height: 45px;\n  border: 1px solid #00000010;\n  border-radius: 12px;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);\n}\n\n.datepicker .rdp-day {\n  width: 45px;\n  max-width: 45px;\n  height: 45px;\n  border-radius: 12px;\n  border: 1px solid #00000010;\n}\n\n.datepicker .rdp-day_selected:focus:not([aria-disabled='true']) {\n  border: 1px solid #000;\n}\n\n.datepicker .rdp-button:focus,\n.rdp-button:active {\n  border: 1px solid transparent;\n}\n\n.rdp-months .rdp-table .rdp-cell .rdp-day_selected {\n  color: white !important;\n  background: #3e79f7 !important;\n}\n\n.rdp-months .rdp-table .rdp-cell .rdp-button_reset:hover {\n  color: white !important;\n  background: #3e79f7 !important;\n}\n\n.rdp-months .rdp-table .rdp-cell .rdp-day_today {\n  color: rgb(0, 0, 0) !important;\n}\n\n[data-theme='dark'] .rdp-months .rdp-table .rdp-cell .rdp-day_today {\n  color: rgb(255, 255, 255) !important;\n}\n\n@media (max-width: 576px) {\n  .datepicker .rdp-caption_label {\n    font-size: 22px;\n    line-height: 26px;\n  }\n\n  .datepicker .rdp-nav {\n    width: 30%;\n  }\n\n  .datepicker .rdp-head_cell {\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  .datepicker .rdp-table {\n    border-spacing: 6px;\n  }\n\n  .datepicker .rdp-tbody {\n    border-radius: 8px;\n  }\n\n  .datepicker .rdp-cell {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n  }\n\n  .datepicker .rdp-day {\n    width: 28px;\n    max-width: 28px;\n    font-size: 14px;\n    height: 30px;\n    border-radius: 8px;\n  }\n}\n\n.statistic-card {\n  border: 1px solid #e6ebf1;\n  font-size: 23px !important;\n\n  .statistic-box {\n    gap: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n}\n\n[data-theme='dark'] .statistic-card {\n  border: 1px solid #4d5b75;\n}\n\n.modal_collapse {\n  background: transparent !important;\n\n  .order_card {\n    border: 1px solid #e6ebf1;\n  }\n}\n\n[data-theme='dark'] .modal_collapse {\n  .order_card {\n    border: 1px solid #4d5b75;\n  }\n}\n\n.addon-menu {\n  .ant-card {\n    border: 1px solid var(--border-color);\n  }\n}\n\n[data-theme='dark'] .addon-menu {\n  .ant-card {\n    border: 1px solid var(--border-color-bg-dark) !important;\n  }\n}\n\n.pac-container {\n  display: none;\n}\n\n.minus-button,\n.plus-button {\n  background: none !important;\n  border: none !important;\n  color: #1a3353 !important;\n\n  &:hover {\n    background: none !important;\n    border: none !important;\n  }\n}\n\n[data-theme='dark'] .minus-button,\n[data-theme='dark'] .plus-button {\n  background: none !important;\n  border: none !important;\n  color: #b4bed2 !important;\n\n  &:hover {\n    background: none !important;\n    border: none !important;\n  }\n}\n\n.order-card {\n  transition: all ease 300ms;\n\n  &:hover {\n    .ant-card-actions {\n      display: block;\n    }\n\n    opacity: 0.8;\n  }\n\n  .ant-card-actions {\n    display: none;\n  }\n\n  .ant-card-meta-title {\n    margin-bottom: 0 !important;\n  }\n\n  .ant-list-items {\n    .ant-list-item {\n      padding: 4px 0 !important;\n      border-bottom: none;\n\n      .ant-space-item {\n        &:first-child {\n          font-size: 16px;\n          font-weight: 600;\n        }\n\n        &:nth-child(2) {\n          text-overflow: ellipsis;\n          overflow: hidden;\n          width: 170px;\n          white-space: nowrap;\n        }\n\n        &:last-child {\n          font-size: 13px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .ant-list {\n    margin-top: 16px;\n  }\n}\n\n.ant-alert {\n  &.new {\n    border-top: 2px solid #16a4d8 !important;\n  }\n\n  &.accepted {\n    border-top: 2px solid #9b5fe0 !important;\n  }\n\n  &.cooking {\n    border-top: 2px solid #e05f5f !important;\n  }\n\n  &.delivered {\n    border-top: 2px solid #8bd346 !important;\n  }\n\n  &.ready {\n    border-top: 2px solid #efdf48 !important;\n  }\n\n  &.canceled {\n    border-top: 2px solid #d64e12 !important;\n  }\n\n  &.on_a_way {\n    border-top: 2px solid #f9a52c !important;\n  }\n\n  &.pause {\n    border-top: 2px solid #552cf9 !important;\n  }\n}\n\n.order-board {\n  max-width: auto;\n  overflow-x: scroll;\n  display: flex;\n  gap: 24px;\n}\n\n.dnd-column {\n  min-width: 250px;\n\n  .h-screen {\n    padding: 0 8px;\n    padding-top: 8px;\n    background: var(--global-bg);\n    border-radius: 8px;\n  }\n\n  .ant-alert {\n    background: var(--global-bg);\n    border-radius: 8px !important;\n    border: 0.5px solid var(--border-color);\n  }\n}\n\n[data-theme='dark'] {\n  .h-screen {\n    background: var(--bg-color);\n  }\n\n  .ant-alert {\n    background: var(--bg-color);\n    border: 0.5px solid var(--ingrediend-border);\n  }\n}\n\n.order-filter {\n  width: 100%;\n\n  .ant-space-item {\n    width: calc((100% - 48px) / 6);\n  }\n}\n\n.hiddin-input {\n  background: rgba(0, 0, 0, 0.5) !important;\n  backdrop-filter: blur(20px) !important;\n}\n\n.search-outlined {\n  .ant-input-suffix {\n    opacity: 0;\n  }\n\n  &:hover {\n    .ant-input-suffix {\n      opacity: 0.5;\n      cursor: pointer;\n    }\n  }\n}\n\n.search-outlined-none {\n  .ant-input-suffix {\n    opacity: 0;\n  }\n}\n\n.video-upload {\n  .ant-upload {\n    display: block;\n    height: 108px !important;\n\n    &.ant-upload-select-picture-card {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n  }\n}\n\n.uploaded-file {\n  background: rgba($color: #fff, $alpha: 0.1);\n  margin-bottom: 8px;\n  border-radius: 8px;\n  padding: 4px 8px;\n\n  .media-item {\n    cursor: pointer;\n    transition: all ease 200ms;\n\n    &:hover {\n      color: #fff;\n    }\n  }\n\n  .delete-media-item {\n    cursor: pointer;\n    transition: all ease 200ms;\n\n    &:hover {\n      color: red;\n    }\n  }\n}\n\n.media-container {\n  width: 100%;\n  height: auto;\n  padding: 4px 16px;\n  font-size: 16px;\n\n  .item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    background: rgba($color: #fff, $alpha: 0.1);\n    border-radius: 8px;\n    padding: 4px 16px;\n    margin-bottom: 8px;\n    .delete-button {\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      transition: all ease 200ms;\n\n      &:hover {\n        color: red;\n      }\n    }\n  }\n}\n\n@media print {\n  .invoice-print-container {\n    padding: 20px 15px !important;\n  }\n}\n\n.pos-system-product-card-title {\n  height: 42px;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
